import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TUpdatePost, TPostBase, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Hook to update a post
 * Only the post author can update their own posts
 *
 * @param postId - Post ID (UUID) to update
 */
export const useUpdatePost = (postId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TPostBase, TError, TUpdatePost>({
    mutationFn: async data => {
      const res = await axios.patch<TPostBase>(`/community-hub/posts/${postId}`, data);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate all posts queries to refresh the feed
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'posts'] });
    },
  });
};
